import {
  benefitIcon1,
  benefitIcon2,
  benefitIcon3,
  benefitIcon4,
  benefitIcon5,
  benefitIcon6,
  benefitImage2,
  companylogo,
  // chromecast,
  // disc02,
  // discord,
  whatsapp,
  facebook,
  // figma,
  // file02,
  // framer,
  // homeSmile,
  instagram,
  // notification2,
  // notification3,
  // notification4,
  // notion,
  portfolioImage1,
  portfolioImage2,
  portfolioImage3,
  portfolioImage4,
  portfolioImage5,
  portfolioImage6,
  portfolioImage7,
  portfolioImage8,
  portfolioImage9,
  portfolioImage10,
  portfolioImage11,
  portfolioImage12,
  portfolioImage13,
  smallportfolioImage1,
  smallportfolioImage2,
  smallportfolioImage3,
  smallportfolioImage4,
  smallportfolioImage5,
  smallportfolioImage6,
  smallportfolioImage7,
  smallportfolioImage8,
  smallportfolioImage9,
  smallportfolioImage10,
  smallportfolioImage11,
  smallportfolioImage12,
  smallportfolioImage13,
  featureImage1,
  featureImage2,
  featureImage3,
  featureImage4,
  featureImage5,
  featureImage6,
  // photoshop,
  // plusSquare,
  // protopie,
  // raindrop,
  // recording01,
  // recording03,
  // roadmap1,
  // roadmap2,
  // roadmap3,
  // roadmap4,
  // roadmap5,
  // roadmap6,
  // searchMd,
  // slack,
  // sliders04,
  linkedin,
  gmail,
  next,
  shopify,
  aws,
  react,
  node,
  go,
  php,
  dotnet,
  flutter,
  python,
  x,
} from "../assets";

export const navigation = [
  {
    id: "0",
    title: "Home",
    url: "/#hero",
  },
  {
    id: "1",
    title: "Services",
    url: "/#services",
  },
  {
    id: "2",
    title: "Products",
    url: "/#products",
  },
  {
    id: "3",
    title: "AI Calling Agent",
    url: "/ai-calling-agent",
  },
  {
    id: "4",
    title: "Our Works",
    url: "/#works",
  },
  {
    id: "5",
    title: "Blogs",
    url: "/blog-categories/all",
  },
  {
    id: "6",
    title: "Contact Us",
    url: "/#contact",
  },
];

// export const heroIcons = [homeSmile, file02, searchMd, plusSquare];

// export const notificationImages = [notification4, notification3, notification2];

export const companyLogos = [
  next,
  aws,
  react,
  dotnet,
  python,
  php,
  flutter,
  go,
  node,
  shopify,
];

export const brainwaveServices = [
  "AI-Driven Smart Interview Simulations",
  "Real-Time Analytics for Performance Optimization",
  "Precision Feedback Powered by Machine Learning",
  "Industry-Specific Scenarios Tailored to You",
  "Data-Driven Confidence Enhancement Tools",
];

export const aiCallingServices = [
  "24/7 AI-Powered Customer Service",
  "Seamless Call Handling for Lead Generation",
  "Instant Appointment Scheduling with AI Efficiency",
  "Human-Like Interaction for Enhanced Customer Engagement",
  "Advanced Analytics for Optimized Call Performance",
];

export const proresumeServices = [
  "AI-Powered Career Enhancement Tools",
  "Personalized Resume Crafting & Optimization",
  "Professional Web Portfolios for Maximum Impact",
  "Mock Interviews with Actionable Feedback",
  "Dynamic Job Profile Optimization Across Platforms",
];

export const rebrandServices = [
  "Strategic Brand Management Solutions",
  "Custom Signage for Retail & Business Spaces",
  "Innovative Digital Marketing Campaigns",
  "Holistic Brand Identity Development",
  "Creative Visual Design for Maximum Impact",
];

// export const brainwaveServicesIcons = [
//   recording03,
//   recording01,
//   disc02,
//   chromecast,
//   sliders04,
// ];

export const roadmap = [
  {
    id: "0",
    title: "🌐 Web Development Mastery",
    text: "Empowering your business with high-performance websites! From sleek e-commerce platforms to SEO-optimized pages and engaging web apps, our websites are built to captivate and deliver results.",
    date: "May 2023",
    status: "done",
    imageUrl: "/animations/web.lottie",
    colorful: true,
    speed: 1,
  },
  {
    id: "1",
    title: "📱 Next-Gen Mobile Apps",
    text: "Transforming ideas into stunning mobile experiences! Whether native iOS/Android apps or hybrid solutions, our user-friendly apps keep your audience connected and engaged on the go.",
    date: "June 2023",
    status: "progress",
    imageUrl: "/animations/mobile.lottie",
    speed: 1,
  },
  {
    id: "2",
    title: "🤖 AI Solutions Redefined",
    text: "Experience the future with AI! From AI Mock Interviews offering real-time feedback to the AI Calling Agent that delivers smart, human-like customer interactions, our AI products redefine productivity and user experience.",
    date: "July 2023",
    status: "done",
    imageUrl: "/animations/ai.lottie",
    speed: 1,
  },
  {
    id: "3",
    title: "🔧 Custom Software Solutions",
    text: "Streamline your business with bespoke software! Whether it’s robust CRM systems, powerful ERP solutions, or cloud-based SaaS platforms, we design tools to elevate your operations and efficiency.",
    date: "September 2023",
    status: "planned",
    imageUrl: "/animations/software.lottie",
    speed: 1,
  },
  {
    id: "4",
    title: "📈 Digital Marketing Amplified",
    text: "Take your brand to the next level with strategic digital marketing! From captivating content to ROI-focused PPC campaigns, SEO, and social media engagement, we ensure your brand leaves a lasting impact.",
    date: "August 2023",
    status: "progress",
    imageUrl: "/animations/digital.lottie",
    speed: 1,
  },
  {
    id: "5",
    title: "🎨 UI/UX Design",
    text: "Designs that mesmerize and convert! Our data-driven interfaces and interactive prototypes deliver stunning visuals and effortless user experiences, keeping your audience hooked.",
    date: "October 2023",
    status: "planned",
    imageUrl: "/animations/ui.lottie",
    speed: 1,
  },
];

export const collabText =
  "With smart automation and top-notch security, it's the perfect solution for teams looking to work smarter.";

// export const collabContent = [
//   {
//     id: "0",
//     title: "Seamless Integration",
//     text: collabText,
//   },
//   {
//     id: "1",
//     title: "Smart Automation",
//   },
//   {
//     id: "2",
//     title: "Top-notch Security",
//   },
// ];

// export const collabApps = [
//   {
//     id: "0",
//     title: "Figma",
//     icon: figma,
//     width: 26,
//     height: 36,
//   },
//   {
//     id: "1",
//     title: "Notion",
//     icon: notion,
//     width: 34,
//     height: 36,
//   },
//   {
//     id: "2",
//     title: "Discord",
//     icon: discord,
//     width: 36,
//     height: 28,
//   },
//   {
//     id: "3",
//     title: "Slack",
//     icon: slack,
//     width: 34,
//     height: 35,
//   },
//   {
//     id: "4",
//     title: "Photoshop",
//     icon: photoshop,
//     width: 34,
//     height: 34,
//   },
//   {
//     id: "5",
//     title: "Protopie",
//     icon: protopie,
//     width: 34,
//     height: 34,
//   },
//   {
//     id: "6",
//     title: "Framer",
//     icon: framer,
//     width: 26,
//     height: 34,
//   },
//   {
//     id: "7",
//     title: "Raindrop",
//     icon: raindrop,
//     width: 38,
//     height: 32,
//   },
// ];

export const pricing = [
  {
    id: "0",
    title: "Basic",
    description: "AI chatbot, personalized recommendations",
    price: "4.99",
    features: [
      "An AI chatbot that can understand your queries",
      "Personalized recommendations based on your preferences",
      "Ability to explore the app and its features without any cost",
    ],
  },
  {
    id: "1",
    title: "Premium",
    description: "Advanced AI chatbot, priority support, analytics dashboard",
    price: "9.99",
    features: [
      "An advanced AI chatbot that can understand complex queries",
      "An analytics dashboard to track your conversations",
      "Priority support to solve issues quickly",
    ],
  },
  {
    id: "2",
    title: "Enterprise",
    description: "Custom AI chatbot, advanced analytics, dedicated account",
    price: "19.99",
    features: [
      "An AI chatbot that can understand your queries",
      "Personalized recommendations based on your preferences",
      "Ability to explore the app and its features without any cost",
    ],
  },
];

export const benefits = [
  {
    id: "0",
    title: "Master Every Interview",
    text: "Access 24/7 AI-driven mock sessions to practice anytime, anywhere, and boost your interview confidence like never before.",
    iconUrl: benefitIcon1,
    imageUrl: benefitImage2,
  },
  {
    id: "1",
    title: "Instant Smart Feedback",
    text: "Get instant, AI-generated feedback on every answer. Identify strengths, fix mistakes, and improve faster than ever before.",
    iconUrl: benefitIcon2,
    imageUrl: benefitImage2,
    light: true,
  },
  {
    id: "2",
    title: "Simulate Real Interviews",
    text: "Experience industry-specific interview scenarios that feel just like the real thing. Walk in prepared and leave with success.",
    iconUrl: benefitIcon3,
    imageUrl: benefitImage2,
    light: true,
  },
  {
    id: "3",
    title: "Track Your Progress Daily",
    text: "Monitor your improvement with real-time analytics and performance reports. See your skills grow after every session.",
    iconUrl: benefitIcon4,
    imageUrl: benefitImage2,
  },
  {
    id: "4",
    title: "Master Clear Communication",
    text: "Get AI-guided tips on how to communicate clearly, confidently, and effectively in every interview answer you give.",
    iconUrl: benefitIcon5,
    imageUrl: benefitImage2,
  },
  {
    id: "5",
    title: "Expert Coaching, No Premium",
    text: "Enjoy expert-level coaching and interview preparation without paying premium prices. Affordable guidance, always accessible.",
    iconUrl: benefitIcon6,
    imageUrl: benefitImage2,
    light: true,
  },
];
export const featureList = [
  {
    id: "0",
    title: "Always-On Assistance",
    description:
      "Ensure your customers are always heard with round-the-clock AI-powered assistance, delivering seamless support anytime, anywhere.",
    icon: featureImage1,
  },
  {
    id: "1",
    title: "Instant Call Routing",
    description:
      " Streamline customer experiences with intelligent call routing, connecting every query to the right team instantly and effortlessly.",
    icon: featureImage2,
  },
  {
    id: "2",
    title: "Voice-Activated Precision",
    description:
      "Enable smooth and natural conversations with advanced voice recognition, ensuring every interaction feels fluid and human-like.",
    icon: featureImage3,
  },
  {
    id: "3",
    title: "Human-Like Conversations",
    description:
      "Build meaningful connections through personalized interactions that understand your customers’ needs and preferences.",
    icon: featureImage4,
  },
  {
    id: "4",
    title: "Data-Driven Insights & Reports",
    description:
      "Gain actionable insights with real-time analytics and reports, empowering you to make informed decisions for better results.",
    icon: featureImage5,
  },
  {
    id: "5",
    title: "Seamless CRM Integration",
    description:
      "Effortlessly sync your AI calling agent with your existing CRM systems, ensuring smooth data flow and enhanced customer management",
    icon: featureImage6,
  },
];
export const portfolio = [
  {
    id: "1",
    title: "AI Hiring Partner",
    text: "Ai Hiring Services and Consulting",
    siteUrl: "https://www.hiringpartner.ai/",
    type: "Saas",
    imageUrl: portfolioImage9,
    smallImageUrl: smallportfolioImage9,
  },
  {
    id: "2",
    title: "Evolve Fits",
    text: "Fitness Booking App",
    siteUrl: "https://evolvefits.com/",
    type: "Mobile and Web App",
    imageUrl: portfolioImage13,
    smallImageUrl: smallportfolioImage13,
    inProgress: true,
  },
  // {
  //   id: "2",
  //   title: "AI Mock Interview",
  //   text: "AI-based interview prep",
  //   siteUrl: "https://www.themockinterview.com/",
  //   type: "Career Tools",
  //   imageUrl: portfolioImage10,
  //   smallImageUrl: smallportfolioImage10,
  // },
  {
    id: "3",
    title: "Proresumes",
    text: "Resume Writing and Career Services",
    siteUrl: "https://proresumes.in/",
    type: "Ecommerce",
    imageUrl: portfolioImage1,
    smallImageUrl: smallportfolioImage1,
  },
  {
    id: "4",
    title: "Builder's Buddy",
    text: "Construction Materials & Services Marketplace",
    siteUrl: "https://buildersbuddy.in/",
    type: "Ecommerce",
    imageUrl: portfolioImage11,
    smallImageUrl: smallportfolioImage11,
  },
  {
    id: "5",
    title: "Bafar Foods",
    text: "Frozen Food Products",
    siteUrl: "https://bafarfoods.com/",
    type: "Ecommerce",
    imageUrl: portfolioImage2,
    smallImageUrl: smallportfolioImage2,
  },
  {
    id: "6",
    title: "Alde Farms",
    text: "Organic dairy products",
    siteUrl: "https://aldefarms.com/",
    type: "Portfolio",
    imageUrl: portfolioImage12,
    smallImageUrl: smallportfolioImage12,
  },
  {
    id: "7",
    title: "Care Source Global",
    text: "Medical Equipment Supply",
    siteUrl: "https://caresourceglobal.com/",
    type: "E-commerce",
    imageUrl: portfolioImage5,
    smallImageUrl: smallportfolioImage5,
  },

  {
    id: "8",
    title: "Jazara",
    text: "Accounting and Financial Services",
    siteUrl: "https://jazara.ae/",
    type: "Agency",
    imageUrl: portfolioImage6,
    smallImageUrl: smallportfolioImage6,
  },
  {
    id: "9",
    title: "Maselite",
    text: "General Trading and Ecommerce",
    siteUrl: "https://maseliteuae.com/",
    type: "E-commerce",
    imageUrl: portfolioImage7,
    smallImageUrl: smallportfolioImage7,
  },
  {
    id: "10",
    title: "Bin Dubai",
    text: "Business Consultancy Services",
    siteUrl: "https://bindubai.ae/",
    type: "Consultancy",
    imageUrl: portfolioImage8,
    smallImageUrl: smallportfolioImage8,
  },
  {
    id: "11",
    title: "Blacksmith",
    text: "Construction Services",
    siteUrl: "https://www.blacksmith.qa/",
    type: "Corporate",
    imageUrl: portfolioImage3,
    smallImageUrl: smallportfolioImage3,
  },
  {
    id: "12",
    title: "Venture Point",
    text: "Accounting and Financial Services",
    siteUrl: "https://www.venturepoint.ae/",
    type: "Corporate",
    imageUrl: portfolioImage4,
    smallImageUrl: smallportfolioImage4,
  },
];

export const socials = [
  {
    id: "0",
    title: "Whatsapp",
    iconUrl: whatsapp,
    url: "https://wa.me/+919539642647",
  },
  {
    id: "1",
    title: "Instagram",
    iconUrl: instagram,
    url: "https://www.instagram.com/bafar_labs/",
  },
  {
    id: "2",
    title: "Linkedin",
    iconUrl: linkedin,
    url: "https://www.linkedin.com/company/bafar-labs/",
  },
  // {
  //   id: "3",
  //   title: "Facebook",
  //   iconUrl: facebook,
  //   url: "#",
  // },

  {
    id: "4",
    title: "X",
    iconUrl: x,
    url: "https://www.x.com/bafarlabs",
  },
  {
    id: "5",
    title: "Gmail",
    iconUrl: gmail,
    url: "mailto:info@bafarlabs.com",
  },
];
